import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().max(100);
const savedSchema = z.string().max(100);
const jsonSchema = z.string();
/**
 * 国内輸送手配業者その他(値オブジェクト)のメタデータ。
 *
 *  */
export const domesticDelivererOtherMeta = new ValueObjectMetaString(
  "DomesticDelivererOther",
  "\u56FD\u5185\u8F38\u9001\u624B\u914D\u696D\u8005\u305D\u306E\u4ED6",
  messageId(
    "lbl.\u56FD\u5185\u8F38\u9001\u624B\u914D\u696D\u8005\u305D\u306E\u4ED6"
  ),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
